module.exports = __webpack_public_path__ + "static/savingsCard-9e7d02384342009950b13c6483068155.png";